import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UserService } from "../../../../shared";
import { SchoolService } from "../../../../shared/services/school.service";
import { AcademyService } from "../../../Report/report-services/academy.service";
import { GradeLevelService } from "../../../Report/report-services/grade-level.service";
import { GroupService } from "../../../Report/report-services/group.service";
import { HomeroomService } from "../../../Report/report-services/homeroom.service";
import { BTBusHistorySelectorBusRequest } from "../shared/BTBusHistorySelectorBusRequest";
import { BTBusHistorySelectorStudentRequest } from "../shared/BTBusHistorySelectorStudentRequest";
import { DataService_BusTrackerBusHistory } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-bus-history-selector",
	templateUrl: "./bus-history-selector.component.html",
	styleUrls: ["./bus-history-selector.component.css"],
})
export class BusHistorySelectorComponent implements OnInit {
	constructor(
		private userService: UserService,
		private schoolService: SchoolService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService,
		private mapService: DataService_BusTrackerBusHistory
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchool();
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//#region Data
	/////////////////////////////////////////////////////////////////////////////////////////////////

	@Input() StartDate: any;
	@Input() EndDate: any;
	@Output() SelectedChanged: EventEmitter<any> = new EventEmitter();

	user: any;

	SearchMode: any = "Bus";
	lstSearchMode: any = ["Bus", "Student"];

	ActiveID: any = -1;
	lstActive: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	Filter: any = "";

	SchoolLoading: any = false;
	School: any;
	lstSchool: any = [];

	GradeLevelLoading: any = false;
	GradeLevel: any;
	lstGradeLevel: any = [];

	AcademyLoading: any = false;
	Academy: any;
	lstAcademy: any = [];

	HomeroomLoading: any = false;
	Homeroom: any;
	lstHomeroom: any = [];

	GroupLoading: any = false;
	Group: any;
	lstGroup: any = [];

	TableLoading: any = false;

	ApplicationItemID: any = "709646F0-A8C5-4194-BBC9-24514962B403";

	lstStudentSearchData: any = [];
	lstBusSearchData: any = [];
	SelectedBuses: any = [];
	SelectedPersons: any = [];

	errorMessage: any = "";

	//#endregion
	/////////////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//#region Load Data
	/////////////////////////////////////////////////////////////////////////////////////////////////

	loadSchool() {
		var result = this.schoolService.loadSchoolList(this.ApplicationItemID);
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolName: "All",
					SchoolFullName: "All",
				});

				this.School = this.lstSchool[0];

				this.loadGradeLevel();
			},
			(error) => {}
		);
	}

	loadGradeLevel() {
		var result = this.gradelevelService.loadGradeLevelList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All Grade Levels",
					});
				}

				this.GradeLevel = this.lstGradeLevel[0];

				this.loadAcademy();
			},
			(error) => {}
		);
	}

	loadAcademy() {
		var result = this.academyService.loadAcademyList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All Academies",
					});
				}

				this.Academy = this.lstAcademy[0];

				this.loadHomeroom();
			},
			(error) => {}
		);
	}

	loadHomeroom() {
		var result = this.homeroomService.loadHomeroomList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomId: -1,
						HomeRoom: "All Homerooms",
					});
				}

				this.Homeroom = this.lstHomeroom[0];

				this.loadGroup();
			},
			(error) => {}
		);
	}

	loadGroup() {
		var result = this.groupService.loadGroupList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All Groups",
					});
				}

				this.Group = this.lstGroup[0];
			},
			(error) => {}
		);
	}

	//#endregion
	/////////////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////////////////////////////
	onSearch() {
		this.errorMessage = "";

		if (this.SearchMode == "Bus") {
			this.onBusSearch();
		} else if (this.SearchMode == "Student") {
			this.onStudentSearch();
		}
	}

	onBusSearch() {
		this.TableLoading = true;

		//
		// Create Request
		//

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY HH:mm:00");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY HH:mm:00");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Start Date";
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid End Date";
			return;
		}

		let parms: BTBusHistorySelectorBusRequest = {
			StartDate: fsDate,
			EndDate: feDate,
			Active: this.ActiveID,
			UserID: this.user.userID,
			Filter: this.Filter,
		};

		//
		// Call SP
		//

		var result = this.mapService.BusHistorySelectorBusModeSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstBusSearchData = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	onStudentSearch() {
		this.TableLoading = true;

		//
		// Create Request
		//

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY HH:mm:00");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY HH:mm:00");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Start Date";
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid End Date";
			return;
		}

		let parms: BTBusHistorySelectorStudentRequest = {
			StartDate: fsDate,
			EndDate: feDate,
			SchoolID: this.School.SchoolID,
			GradeLevelID: this.GradeLevel.GradeLevelID,
			AcademyID: this.Academy.AcademyId,
			HomeroomID: this.Homeroom.HomeroomId,
			GroupID: this.Group.GroupID,
			Active: this.ActiveID,
			UserID: this.user.userID,
			Filter: this.Filter,
		};

		//
		// Call SP
		//

		var result = this.mapService.BusHistorySelectorStudentModeSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstStudentSearchData = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////////////////////////////
	onSearchModeChange(val) {
		this.SearchMode = val;
		this.Filter = "";

		//Clear Results
		this.SelectedBuses = [];
		this.lstBusSearchData = [];
		this.SelectBusesOnMap();

		//Load?
	}

	onBusSelectChange(val) {
		this.SelectedBuses = val;

		this.SelectBusesOnMap();
	}

	onStudentSelectChange(val) {
		var lstBuses: any = [];
		var lstPersons: any = [];

		for (var z = 0; z < val.length; z++) {
			var next = val[z];

			for (var x = 0; x < next.lstBusIDs.length; x++) {
				var nextID = next.lstBusIDs[x];

				var nextEntry: any = {
					BusID: nextID,
				};

				lstBuses = [...lstBuses, nextEntry];
			}
		}

		for (var z = 0; z < val.length; z++) {
			var next = val[z];

			var nextEntry: any = {
				PersonID: next.PersonID,
			};

			lstPersons = [...lstPersons, nextEntry];
		}

		this.SelectedBuses = lstBuses;
		this.SelectedPersons = lstPersons;

		this.SelectBusesOnMap();
	}

	onFilterKeyDown(event) {
		if (event.key == "Enter") {
			var SearchButton = document.getElementById("SearchButton");

			SearchButton.focus();
			SearchButton.click();
		}
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////////////////////////////

	SelectBusesOnMap() {
		let lstBusIDs: any = [];
		let lstStudentIDs: any = [];

		try {
			lstBusIDs = Array.from(new Set(this.SelectedBuses.map((item: any) => item.BusID)));

			lstStudentIDs = Array.from(new Set(this.SelectedPersons.map((item: any) => item.PersonID)));
		} catch (e) {
			e.toString();
		}

		if (this.SearchMode == "Bus") {
			this.SelectedChanged.emit({ Buses: lstBusIDs, Students: [] });
		} else if (this.SearchMode == "Student") {
			this.SelectedChanged.emit({
				Buses: lstBusIDs,
				Students: lstStudentIDs,
			});
		}
	}

	IsLoading() {
		return false;
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
}
